import {PrLabel} from '../../interfaces/process-reports/pr-label';


export class PrLabelFactory {

  /**
   *
   * @param prLabel
   */
  public static formObject(prLabel: any): PrLabel {
    return new class implements PrLabel {
      color: string = prLabel.color;
      id: number = prLabel.id;
      name: string = prLabel.name;
    };
  }

  /**
   *
   * @param prLabels
   */
  public static fromArray(prLabels: any[]): PrLabel[] {
    return prLabels.map(_prLabel => this.formObject(_prLabel));
  }

}
